export default function normalizeSearchText<V extends string | undefined>(
  value: V
) {
  if (typeof value === 'string') {
    return value.replace(/\s+/, ' ').trim().toLowerCase()
  }

  return ''
}
